/* Casa Renata — título + embalagem dinâmicos por tamanho (SÓ jogos de cama).
   Ativa apenas em páginas cujo produto tem .cr-desc[data-cr-jogo] (marcado pelo motor).
   Regra: Solteiro leva 1 fronha a menos (perde 1 peça). */
(function () {
  var SIZES = ['Solteiro King', 'Solteiro', 'Casal', 'Queen', 'King']; // ordem: mais específico 1º
  function init() {
    var desc = document.querySelector('.cr-desc[data-cr-jogo]');
    if (!desc) return; // não é jogo -> não faz nada
    var pecas = parseInt(desc.getAttribute('data-cr-jogo'), 10) || 3;

    // título do produto: prioriza H1 real fora de nav/breadcrumb; evita pegar o breadcrumb
    var titleEl = null;
    function notInNav(el){ return !el.closest('nav, header, .breadcrumb, [class*="breadcrumb"], [class*="breadcrumbs"]'); }
    var groups = [document.querySelectorAll('h1'), document.querySelectorAll('.product__title, [class*="product"][class*="title"]'), document.querySelectorAll('h2')];
    for (var g = 0; g < groups.length && !titleEl; g++) {
      for (var i = 0; i < groups[g].length; i++) {
        var el = groups[g][i];
        if (/Jogo de Cama/i.test(el.textContent) && el.offsetParent !== null && notInNav(el)) { titleEl = el; break; }
      }
    }
    var baseTitle = titleEl ? titleEl.textContent.trim() : null;
    var emb = desc.querySelector('.cr-embalagem');

    function selectedSize() {
      // 1) inputs checados
      var inputs = document.querySelectorAll('input:checked, option:checked, [aria-checked="true"], [data-selected="true"], .selected, .is-selected');
      for (var i = 0; i < inputs.length; i++) {
        var v = (inputs[i].value || inputs[i].getAttribute('data-value') || inputs[i].textContent || '').trim();
        for (var s = 0; s < SIZES.length; s++) if (v.toLowerCase() === SIZES[s].toLowerCase()) return SIZES[s];
      }
      // 2) strong.value sob label "Tamanho"
      var labels = document.querySelectorAll('.label, legend, .form__label');
      for (var l = 0; l < labels.length; l++) {
        if (/tamanho/i.test(labels[l].textContent)) {
          var val = labels[l].parentNode.querySelector('.value, strong');
          if (val) { var t = val.textContent.trim();
            for (var s2 = 0; s2 < SIZES.length; s2++) if (t.toLowerCase() === SIZES[s2].toLowerCase()) return SIZES[s2]; }
        }
      }
      return null;
    }

    function embItems(size) {
      var umaFronha = /^solteiro/i.test(size || '');
      var fronha = umaFronha ? '1 Fronha com 4 abas (50 × 70 cm)' : '2 Fronhas com 4 abas (50 × 70 cm)';
      var items = ['1 Lençol com elástico'];
      if (pecas === 4) items.push('1 Lençol de cima');
      items.push(fronha);
      var totalPecas = items.length; // nº real de peças p/ esse tamanho
      return { items: items, total: totalPecas };
    }

    function apply() {
      var size = selectedSize();
      // título
      if (titleEl && baseTitle) {
        var t = baseTitle;
        if (size) {
          t = /\d+\s*Pe[çc]as/i.test(baseTitle)
            ? baseTitle.replace(/(\d+\s*Pe[çc]as)/i, '$1 ' + size)
            : baseTitle + ' ' + size;
        }
        if (titleEl.textContent.trim() !== t) titleEl.textContent = t;
      }
      // embalagem
      if (emb && size) {
        var e = embItems(size);
        emb.innerHTML = e.items.map(function (it) {
          return '<li style="margin-bottom:6px">' + it + '</li>';
        }).join('');
        // nota de nº de peças p/ solteiro
        if (/^solteiro/i.test(size)) {
          emb.innerHTML += '<li style="margin-bottom:6px;color:#888;list-style:none;margin-left:-20px"><em>No tamanho ' + size + ' o conjunto acompanha ' + e.total + ' peças (1 fronha).</em></li>';
        }
      }
    }

    apply();
    document.addEventListener('change', function () { setTimeout(apply, 60); }, true);
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-option-id], .variant-picker, fieldset, label')) setTimeout(apply, 120);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
